import { ReactNode } from "react";
import { Sheet as BaseSheet } from "react-modal-sheet";
import styles from "./ModalSheet.module.scss";

interface IModalSheetProps {
  isOpen: boolean;
  children: ReactNode;
  onClose?: (value: boolean) => void;
  onCloseEnd?: (value: boolean) => void;
  classNameWrapper?: string;
  classNameContainer?: string;
  classNameContent?: string;
}

export default function ModalSheet({
  isOpen,
  children,
  onClose,
  onCloseEnd,
  classNameWrapper = "",
  classNameContainer = "",
  classNameContent = "",
}: IModalSheetProps) {
  return (
    <>
      <BaseSheet
        className={`${styles.wrapper} ${classNameWrapper}`}
        snapPoints={[-80]}
        detent="content-height"
        isOpen={isOpen}
        onClose={() => onClose && onClose(true)}
        onCloseEnd={() => onCloseEnd && onCloseEnd(true)}
        onDrag={() => onClose && onClose(true)}
        tweenConfig={{ ease: "easeOut", duration: 0.1 }}
      >
        <BaseSheet.Container className={`${styles.container} ${classNameContainer}`}>
          <BaseSheet.Header className={styles.header} disableDrag={false} />
          <BaseSheet.Content disableDrag className={`${styles.content} ${classNameContent}`}>
            {children}
          </BaseSheet.Content>
        </BaseSheet.Container>
        <BaseSheet.Backdrop onTap={() => onClose && onClose(true)} />
      </BaseSheet>
    </>
  );
}
